import { format } from "date-fns";
import { v4 as uuidv4 } from "uuid";

export const uuid = (): string => {
  return uuidv4();
};

export const formatDate = (date: string, formatStr: string): string => {
  return format(new Date(date), formatStr);
};
